import { type FC, lazy, Suspense } from 'react';
import { graphql, useFragment } from 'react-relay';

import { type PdpSharedDibsPromiseModalLazy_user$key } from './__generated__/PdpSharedDibsPromiseModalLazy_user.graphql';

const PdpSharedDibsPromiseModalLazyComponent = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedDibsPromiseModalLazy" */ './PdpSharedDibsPromiseModal'
        )
);

const userFragment = graphql`
    fragment PdpSharedDibsPromiseModalLazy_user on User {
        ...PdpSharedDibsPromiseModal_user
    }
`;

type Props = {
    user: PdpSharedDibsPromiseModalLazy_user$key | null | undefined;
    isOpen: boolean;
    onClose: () => void;
    inline?: boolean;
};

export const PdpSharedDibsPromiseModalLazy: FC<Props> = ({ user: userRef, isOpen, onClose }) => {
    const user = useFragment(userFragment, userRef);

    return (
        <Suspense fallback={null}>
            <PdpSharedDibsPromiseModalLazyComponent user={user} isOpen={isOpen} onClose={onClose} />
        </Suspense>
    );
};
